import React from 'react';

import {Helmet} from 'views/module';

import LeadFunnelScene from 'views/scenes/metrics/lead_funnel/LeadFunnel';

const LeadFunnelPage = () => {
  return (
    <>
      <Helmet>
        <title>Quilt: Lead Funnel</title>
      </Helmet>
      <LeadFunnelScene />
    </>
  );
};

export default LeadFunnelPage;
